import store from './store'
import { format, parse } from 'date-fns'
import request from '@/api/request'

// ////////////////////////////////////////////////////////////////////////////
// Utils
// ////////////////////////////////////////////////////////////////////////////

export default {
  printCopyright () {
    const styles = ['background:#30a8de;padding:1px;border-radius:3px;color: #fff', 'background:transparent;']
    const message = 'Powered by ITEREO Travel Planner - All rights reserved: ©Global Encounters™ 1999-'
    console.log(`%c ${message}${new Date().getFullYear()} `, styles[0])
  },

  backgroundImage (url) {
    const bgUrl = url
    const bgPosition = `background-position: center top;`
    const bgSize = `background-size: cover;`
    const bgRepeat = `background-repeat: no-repeat;`
    const bgImage = `background-image: url(${bgUrl});`
    return `${bgPosition}${bgSize}${bgRepeat}${bgImage}`
  },

  validateAutoLogin () {
    const userString = localStorage.getItem('auth-data')

    if (userString) {
      const userData = JSON.parse(userString)
      store.commit('auth/SET_AUTH_DATA', userData)
    }

    request.interceptors.response.use(
      response => response,
      error => {
        if (!error.response) return Promise.reject(error)

        if (error.response.status >= 500) {
          window.location.href = '/404'
        }

        if (error.response.status === 401) {
          store.dispatch('auth/refreshToken')
            .then((response) => {})
            .catch(error => {
              if (error.response && error.response.status > 400) { // 401 || 403
                store.dispatch('auth/removeToken')
              }
            })
        }

        const hasEndpoint = error.response.config.url.includes('files/list-upload')

        if (error.response.status === 403 && !hasEndpoint) {
          window.location.href = '/'
        }
        return Promise.reject(error)
      }
    )
  }
}

export function uuid (length = 17) {
  return Math.random().toString(length).slice(2)
}

export function randomArray (length) {
  return new Array(length).fill().map((element, index) => {
    const id = index + 1
    return { id, name: `ITEM ${id}`, order: id }
  })
}

export function randomInt (min, max) {
  const _min = Math.ceil(min)
  const _max = Math.floor(max)
  return Math.floor(Math.random() * (_max - _min + 1)) + _min
}

export function formatDate (value, formatValue = 'yyyy-MM-dd') {
  return format(new Date(value), formatValue)
}

export function parseDate (date, parseString = 'yyyy-MM-dd') {
  return new Date(parse(date, parseString, new Date()))
}

export function generateArray (size = 10) {
  return Array(size).fill().map((item, i) => {
    const id = `${i + 1}`
    return {
      id,
      value: id,
      text: `Item ${id}`
    }
  })
}

export function grouByPair (arr) {
  return arr.reduce(function (result, value, index, array) {
    if (index % 2 === 0) {
      result.push(array.slice(index, index + 2))
    }
    return result
  }, [])
}

// ////////////////////////////////////////////////////////////////////////////
// Localstorage
// ////////////////////////////////////////////////////////////////////////////

export function saveStatePlugin (store) {
  store.subscribe(
    (mutation, state) => {
      if (state.opportunity.newOpportunity) {
        const uuid = state.opportunity.newOpportunity.uuid
        const key = `newopportunity/${uuid}`
        let data = state.opportunity.newOpportunity.payload
        if (uuid) {
          localStorage.setItem(key, JSON.stringify(data))
        }
      }
    }
  )
}

export function restoreNewOpportunity (uuid) {
  const key = `newopportunity/${uuid}`
  const data = localStorage.getItem(key)
  if (data) {
    return JSON.parse(data)
  }
}

export function isEmpty (obj) {
  return Object.keys(obj).length === 0 && obj.constructor === Object
}

export const getValidatedImages = (currentImages, newImages, howManyElements = null) => {
  const currentValidatedImages = Array.isArray(currentImages) ? currentImages : [currentImages]
  const newValidatedImages = Array.isArray(newImages) ? newImages : [newImages]
  const allImages = [...currentValidatedImages, ...newValidatedImages]
    .filter(image => image && ![null, undefined, 0].includes(image.asset_id))
  const repeatedImagesByAssetId = allImages
    .filter((image, index, self) => index !== self.findIndex(t => t.asset_id === image.asset_id))
    .map(image => image.id)
  const imagesWithoutAsset = allImages
    .filter(image => (image.url_image && !image.url_image.length > 0) || [null, undefined, 0].includes(image.asset_id))
    .map(image => image.id)
  const imagesToDelete = [...repeatedImagesByAssetId, ...imagesWithoutAsset ]
  const allImagesWithStatus = allImages.map(image => {
    if (imagesToDelete.includes(image.id)) {
      return { ...image, status: -1 }
    }
    return image
  })
  if (typeof howManyElements === 'number') {
    return allImagesWithStatus.reduce((acc, image, index, array) => {
      const isImageToDelete = array.length - 1 - howManyElements < index
      return [...acc, {
        ...image,
        status: isImageToDelete ? 1 : -1
      }]
    }, [])
  }
  return allImagesWithStatus
}

export const buildNewAssets = (images = []) => {
  if (!images) return [];

  return images
    .filter(image => !image.id)
    .map(i => {
      if (Number(i.assetId) > 0) {
        return { id: null, asset_id: i.assetId }
      }
      if (Number(i.asset_id) > 0) {
        return { id: null, asset_id: i.asset_id }
      }
      if (Number(i.assetId) === 0 || Number(i.asset_id) === 0) {
        return { id: null, asset_id: 0 }
      }
      return { id: null }
    });
}

export const getValidatedExportSection = (formSelectSections, exportSectionId = 0, currentExportType = "") => {
  if (formSelectSections === null || formSelectSections === undefined) return {
    id: null,
    active: true,
    id_content: exportSectionId
  }
  const settingsByExportType = formSelectSections.find(exportType => {
    return exportType.type === currentExportType
  }) || {}
  if (settingsByExportType.contents === undefined) return {
    id: null,
    active: true,
    id_content: exportSectionId
  }
  const sectionFound = settingsByExportType.contents.find(section => {
    return section.id_content === exportSectionId
  })
  return {
    ...sectionFound,
    active: sectionFound !== undefined,
    id_content: exportSectionId,
    id: sectionFound !== undefined ? sectionFound.id : null
  }
}
